import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { A3LEmployee } from '../../../core/models/a3LEmployee.model';
import { A3LEmployeeService } from '../../../core/services/a3LEmployee.service';
import { ISelector } from '../interfaz/ISelector';

@Component({
  selector: 'app-employee-selector',
  templateUrl: './employee-selector.component.html',
  styleUrls: ['./employee-selector.component.scss'],
  providers: [A3LEmployeeService]
})
export class EmployeeSelectorComponent implements OnInit, ISelector<A3LEmployee> {

  constructor(protected employeeService: A3LEmployeeService) { }

  entities: A3LEmployee[];

  @Output() selectedValueChange = new EventEmitter<A3LEmployee>();

  @Input() value: number | string;
  @Input() placeHolder: string = '';
  @Input() dataSize: number = 7;
  @Input() required: boolean;

  loading:boolean= false;

  private _companyCode: string;
  @Input() set companyCode(value: string) {
    this._companyCode = value;
    if (value !== '') {
      this.getEntities();
    }
  }
  get companyCode(): string {
    return this._companyCode;
  }

  getEntities() {
    if(!this.companyCode)
    {
      return;
    }

    this.loading = true;
    this.employeeService.getAllForSelect(this.companyCode).subscribe((response: A3LEmployee[]) => {
      if (response) {
        this.entities = response;
      }
      this.loading = false;
    }, error => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  ngOnInit() {
    //this.getEntities();
  }

  onSelectedValueChange(event) {
    this.value = event;
    const entity = this.entities.find(x=> x.employeeCode == event);
    this.selectedValueChange.emit(entity);
  }

}
